import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const hostname = window.location.hostname;
const match = hostname.match(/^([^.]+)\.([^.]+)\.geoz\.com\.br$/);
if (match) {
  const city = match[1].charAt(0).toUpperCase() + match[1].slice(1);
  const appName = `GeoZ ${city}`;
  document.title = appName;
  const meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (meta) meta.setAttribute('content', appName);
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
  caches.keys().then((names) => names.forEach((n) => caches.delete(n)));

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-v2.js', { updateViaCache: 'none' });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
